import React, { Dispatch, SetStateAction, useState } from 'react';
import AssociatedOrgsTitle from './AssociatedOrgsTitle';
import { organizationGroupingByName } from '../helpers/organizationUtils';
import AddkeyOrganizationsModal from '../AddkeyOrganizationsModal';
import { ProductionOrganizationInfo } from 'sr-types/lib/production/v1/graphql';
import { ProductionTypeSuperset } from '../helpers/productionApi';

type AssociatedOrganizationsProps = {
    keyOrganizations: Array<ProductionOrganizationInfo>;
    associatedOrganizations: Array<ProductionOrganizationInfo>;
    workspaceId: string;
    setWorkspace?: Dispatch<SetStateAction<ProductionTypeSuperset>>;
    isReadOnly?: boolean;
    isSaving?: boolean;
};

export const AssociatedOrganizations = ({
    keyOrganizations,
    associatedOrganizations,
    workspaceId,
    setWorkspace,
    isReadOnly,
    isSaving
}: AssociatedOrganizationsProps) => {
    const [isKeyOrganizationsModalOpen, setIsKeyOrganizationsModalOpen] = useState<boolean>(false);

    return (
        <>
            <AssociatedOrgsTitle
                productionOrgs={organizationGroupingByName(keyOrganizations)}
                onAdd={() => setIsKeyOrganizationsModalOpen(true)}
                isReadOnly={isReadOnly}
                isSaving={isSaving}
            />
            {isKeyOrganizationsModalOpen && (
                <AddkeyOrganizationsModal
                    open
                    onClose={() => setIsKeyOrganizationsModalOpen(false)}
                    productionId={workspaceId}
                    organizationsData={associatedOrganizations}
                    keyOrganizations={keyOrganizations}
                    setViewState={setWorkspace}
                />
            )}
        </>
    );
};
